import styled from "@emotion/styled/macro";
import { colors } from "../../../../../../common/styles/theme.styles";

export const TagCategory = styled.div`
    padding-inline: 12px;
    padding-bottom: 16px;
    border-bottom: 1px solid ${colors.gray3};
    
    &:last-child {
        padding-bottom: 0;
        border-bottom: none;
    }
`;

export const TagCategoryTitle = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    font-family: Circular;
    font-weight: 450;
    font-size: 12px;
    line-height: 1.265;
    color: ${colors.darkGray2};
    margin-bottom: 8px;
`;

export const TagsList = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 12px;
`;

export const TagPill = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    background: ${colors.lightGray2};
    border-radius: 20px;
    padding: 6px 8px;
    font-family: Circular;
    font-size: 12px;
    font-weight: 450;
    color: ${colors.darkGray1};
    transition: all 0.2s ease;
    cursor: pointer;
`;

export const TagText = styled.span`
    white-space: nowrap;
`;

export const RemoveTagButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    border: none;
    background: rgba(0, 0, 0, 0.20);
    border-radius: 50%;
    color: #fff;
    cursor: pointer;
    font-size: 14px;
    font-weight: 700;
    padding: 0;
    
    &:hover {
        background: rgba(0, 0, 0, 0.50);
    }
`;

export const AddButton = styled.button`
    background: ${colors.lightGray2};
    border: none;
    color: ${colors.darkGray1};
    font-family: Circular;
    font-size: 12px;
    font-weight: 450;
    cursor: pointer;
    padding: 6px 14px 6px 12px;
    border-radius: 20px;
`; 